import { Show, type JSX } from "solid-js";
import { Portal } from "solid-js/web";
import { Dialog } from "@ark-ui/solid";
import { IconButton, TextButton } from "../button/Button";
import { useTranslation } from "../../state/i18n";

type TourModalProps = {
  open: boolean;
  image: {
    src: string;
    alt: string;
  };
  title: JSX.Element;
  description: JSX.Element;
  onClose: () => void;
  primaryAction: {
    onClick: () => void;
    label: string;
  };
  secondaryAction?: {
    onClick: () => void;
    label: string;
  };
};

export const TourModal = (props: TourModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog.Root closeOnInteractOutside={false} open={props.open}>
      <Dialog.Context>
        {(context) => (
          <Show when={context().open}>
            <Portal>
              <Dialog.Backdrop class="fixed inset-0 z-10 size-full bg-overlay-default" />
              <Dialog.Positioner class="fixed inset-0 z-10 flex size-full items-center justify-center rounded-lg shadow-elevation-light-5">
                <Dialog.Content class="relative w-120 rounded-lg bg-surface-default">
                  <div class="p-1">
                    <IconButton
                      icon="x"
                      variant="tertiary"
                      class="ml-auto"
                      aria-label={t(($) => $.CLOSE_BUTTON)}
                      onClick={props.onClose}
                    />
                  </div>

                  <img src={props.image.src} alt={props.image.alt} />

                  <div class="p-6">
                    <Dialog.Title class="mb-2 text-header-xl text-primary">{props.title}</Dialog.Title>
                    <Dialog.Description class="text-medium-regular text-secondary">
                      {props.description}
                    </Dialog.Description>

                    <div class="mt-6 ml-auto flex gap-2">
                      <Show when={props.secondaryAction}>
                        {(action) => (
                          <TextButton block variant="secondary" text={action().label} onClick={action().onClick} />
                        )}
                      </Show>
                      <TextButton
                        block
                        autofocus
                        variant="primary"
                        text={props.primaryAction.label}
                        onClick={props.primaryAction.onClick}
                      />
                    </div>
                  </div>
                </Dialog.Content>
              </Dialog.Positioner>
            </Portal>
          </Show>
        )}
      </Dialog.Context>
    </Dialog.Root>
  );
};

export default TourModal;
